import axios from "axios";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";
import { PROFORM_INVOICE_LIST_FAIL, PROFORM_INVOICE_LIST_REQUEST, PROFORM_INVOICE_LIST_SUCCESS, PROFORM_INVOICE_LIST_UPDATE } from "../constats/proforma_invoice.constant";

export const getProformaInvoices = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: PROFORM_INVOICE_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }proforma-invoices${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: PROFORM_INVOICE_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: PROFORM_INVOICE_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: PROFORM_INVOICE_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const changeElementInList = (proformaInvoice) => async(dispatch) => {
    dispatch({
        type: PROFORM_INVOICE_LIST_UPDATE,
        payload: proformaInvoice
    })
}